import { Component, ErrorInfo, ReactNode } from 'react';

import { withTranslation, WithTranslation } from 'react-i18next';

import { ActionLayout } from 'components/layouts/ActionLayout';
import { Box, Button, VStack } from 'components/uikit';

interface Props extends WithTranslation {
  children?: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundaryBase extends Component<Props, State> {
  public state: State = {
    hasError: false,
  };

  public static getDerivedStateFromError(_: Error): State {
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    if (this.state.hasError) {
      return (
        <ActionLayout>
          <ActionLayout.Action>
            <Box
              display='flex'
              w='100%'
              h='100%'
              alignItems='center'
              justifyContent='center'
            >
              <VStack spacing='16px'>
                <h1>{this.props.t('something_went_wrong')}</h1>
                <Button
                  variant='primary'
                  onClick={() => window.location.reload()}
                >
                  {this.props.t('retry')}
                </Button>
              </VStack>
            </Box>
          </ActionLayout.Action>
        </ActionLayout>
      );
    }

    return this.props.children;
  }
}

export const ErrorBoundary = withTranslation('common')(ErrorBoundaryBase);
